import { Component, OnInit, ViewChild, AfterViewInit, Inject } from '@angular/core';
import { FormGroup, FormGroupDirective, FormBuilder, Validators } from '@angular/forms';
import { MatTableDataSource, MatPaginator, MatSort, MatTreeFlattener, MatTreeFlatDataSource, MatDialog } from '@angular/material';
import { ActionModeEnum, AlertService, Constants, WarningDialog, ConfirmationDialog } from 'src/app/shared';
import { SelectionModel } from '@angular/cdk/collections';
import { FlatTreeControl } from '@angular/cdk/tree';
import { SiteService, UserManagementService } from 'src/app/services/index';
import { FeatureModel } from 'src/app/models/index';
import * as cloneDeep from 'lodash/cloneDeep';
import {AllowedSiteSelectionEnum } from 'src/app/shared/index';
export class RoleFeatureItemNode {
  roleRId: string;
  name: string;
  level: number;
  childrentRole: RoleFeatureItemNode[];
  selectable: boolean;
  parentRId: string;
  isExpandable: boolean;
  selected: boolean;
  allowedSiteSelectionNumber: any;
  definition: any;
}
export class RoleFeatureItemFlatNode {
  roleRId: string;
  name: string;
  level: number;
  childrentRole: RoleFeatureItemNode[];
  selectable: boolean;
  parentRId: string;
  isExpandable: boolean;
  allowedSiteSelectionNumber: any;
  definition: any;
}
@Component({
  selector: 'app-role-management',
  templateUrl: './role-management.component.html',
  styleUrls: ['./role-management.component.scss']
})
export class RoleManagementComponent implements OnInit, AfterViewInit {
  @ViewChild('formDirective') formDirective: FormGroupDirective;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('tree') tree;
  formData: FormGroup;
  model: any;
  // tslint:disable-next-line:max-line-length
  modificationType = [ { name : 'All', value : 1 }, { name : 'View', value : 2 }, { name : 'Add/Edit', value : 3 }, { name : 'Delete', value : 4 } ];
  // tslint:disable-next-line:max-line-length
  allowedSiteSelectionNumber = [ { name : 'SINGLE', value : '1', disabled: false }, { name : 'MULTIPLE', value : '2', disabled: false  }, { name : 'NONE', value : '0', disabled: false  }];
  selectedFeatures = '';
  displayedColumns = ['index', 'selected', 'modificationTypeString', 'name'];
  features: FeatureModel[];
  featuresDataSource: MatTableDataSource<any>;
  filterValues = {
    modificationTypeString: '',
    name: '',
  };
  selectedModificationType = {};
  featureNameSearch = '';
  isDisabledEditBtn = true;
  isDisabledAddBtn = false;
  isDisabledDeleteBtn = true;
  isDisabledCancelBtn = true;
  isDisableSeleted = false;
  actionMode = ActionModeEnum.Viewing;
  currentSelectedNode: RoleFeatureItemFlatNode;
  isSelected = false;
  // Event on Tree
  public checklistSelection = new SelectionModel<RoleFeatureItemFlatNode>(true /* mul */);
  /** Map from flat node to nested node. This helps us finding the nested node to be modified */
  public flatNodeMap = new Map<RoleFeatureItemFlatNode, RoleFeatureItemNode>();
  /** Map from nested node to flattened node. This helps us to keep the same object for selection */
  public nestedNodeMap = new Map<RoleFeatureItemNode, RoleFeatureItemFlatNode>();
  /** A selected parent node to be inserted */
  public selectedParent: RoleFeatureItemFlatNode | null = null;
  public activeNode: any;
  public treeControl: FlatTreeControl<RoleFeatureItemFlatNode>;
  public treeFlattener: MatTreeFlattener<RoleFeatureItemNode, RoleFeatureItemFlatNode>;
  public dataSource: MatTreeFlatDataSource<RoleFeatureItemNode, RoleFeatureItemFlatNode>;
  // organizationDataSource = new MatTableDataSource<OrganizationModel>();
  public selectedNode: RoleFeatureItemFlatNode;
  // End Event On Tree
  /* Begin Function on Tree*/
  public getLevel = (node: RoleFeatureItemFlatNode) => node.level;

  public isExpandable = (node: RoleFeatureItemFlatNode) => node.isExpandable;

  public getChildren = (node: RoleFeatureItemNode): RoleFeatureItemNode[] => node.childrentRole;

  // tslint:disable-next-line:max-line-length
  public hasChild = (_: number, _nodeData: RoleFeatureItemFlatNode) => _nodeData.childrentRole !== undefined && _nodeData.childrentRole.length > 0;

  public hasNoContent = (_: number, _nodeData: RoleFeatureItemFlatNode) => _nodeData.name === '';
  /**
   * Transformer to convert nested node to flat node. Record the nodes in maps for later use.
   */
  public transformer = (node: RoleFeatureItemNode, level: number) => {
    const existingNode = this.nestedNodeMap.get(node);
    const flatNode = existingNode && existingNode.roleRId === node.roleRId
        ? existingNode
        : new RoleFeatureItemFlatNode();
    flatNode.name = node.name;
    flatNode.level = level;
    flatNode.roleRId = node.roleRId;
    flatNode.definition = node.definition;
    // flatNode.isExpandable = !!node.childrentRole;
    flatNode.childrentRole = node.childrentRole;
    flatNode.selectable = node.selectable;
    flatNode.parentRId = node.parentRId;
    flatNode.isExpandable = !!node.childrentRole;
    flatNode.allowedSiteSelectionNumber = node.allowedSiteSelectionNumber;
    this.flatNodeMap.set(flatNode, node);
    this.nestedNodeMap.set(node, flatNode);
    if (node.selected) {
      this.checklistSelection.select(flatNode);
    }
    return flatNode;
  }
  constructor(
    private fb: FormBuilder,
    private siteService: SiteService,
    private userManagementService: UserManagementService,
    public dialog: MatDialog,
    private alertService: AlertService) {
    this.formData = this.fb.group({
      roleNameCtr: ['',  [Validators.required, Validators.maxLength(250)]],
      definitionCtr: ['',  [Validators.maxLength(300)]],
      allowedSiteSelectionNumberCtr: ['',  [Validators.required]],
    });
    this.setEnableForm();
    this.model = {};
    // this.features = this.fakeData();
    // this.featuresDataSource = new MatTableDataSource<any>(this.features);
    // this.featuresDataSource.filterPredicate = this.createFilter();
    this.getFeatures();
    // Bind Tree View
    this.treeFlattener = new MatTreeFlattener(this.transformer, this.getLevel,
      this.isExpandable, this.getChildren);
      this.treeControl = new FlatTreeControl<RoleFeatureItemFlatNode>(this.getLevel, this.isExpandable);
      this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
      this.getRoleTree();
  }

  ngOnInit() {
  }
  ngAfterViewInit() {
  }
  // Event On Tree
  private getRoleTree = () => {
    this.userManagementService.getRoleTree().subscribe(data => {
      this.dataSource.data = this.mapToRoleFreatureItemNode(data.data);
      this.tree.treeControl.expandAll();
      // const first = this.dataSource.data[0];
      // this.currentSelectedNode = first;
      //   const element: HTMLElement = <any>document.getElementById('chkRole_' + first.roleRId) as HTMLElement;
      //   element.click();

    });
  }
  private getRoleTreeAndSetSelectedRole = () => {
    this.userManagementService.getRoleTree().subscribe(data => {
      this.dataSource.data = this.mapToRoleFreatureItemNode(data.data);
      this.tree.treeControl.expandAll();
      if (this.currentSelectedNode) {
        const element: HTMLElement = <any>document.getElementById('chkRole_' + this.currentSelectedNode.roleRId) as HTMLElement;
        element.click();
      }
    });
  }
  private mapToRoleFreatureItemNode = (data: any) => {
    return  data as RoleFeatureItemNode[];
  }
  public onCheckedNodeChange = (node: RoleFeatureItemFlatNode, hasChild: boolean, event?: any) => {
      if (event) {
        event.preventDefault();
      }
      this.clearSelectedFeatures();
      const isSelected = this.checklistSelection.isSelected(node);
      this.checklistSelection.deselect(...this.treeControl.dataNodes);
      if (isSelected) {
        this.checklistSelection.deselect(node);
      } else {
       this.checklistSelection.select(node);
      }
      // this.checklistSelection.select(node);
      // hasChild ? this.onSelectedParent(node) : this.onSelectedLastChild(node);
      if (this.checklistSelection.isSelected(node)) {
        this.bindRoleModelBaseOnSelectedRole(node, true, hasChild);
        this.setDisabledAllowedSiteSelectionNumber(true, node);
      } else {
        this.bindRoleModelBaseOnSelectedRole(node, false, hasChild);
        this.setDisabledAllowedSiteSelectionNumber(false, null);
      }
      return isSelected;
  }
  private bindRoleModelBaseOnSelectedRole = (node: any, isSelected: boolean, hasChild: boolean) => {
    this.isDisabledAddBtn = false;
    if (isSelected) {
      this.isDisabledAddBtn = node.selectable;
      this.currentSelectedNode = node;
      this.isDisabledEditBtn = false;
      this.isDisabledDeleteBtn = false;
      //
      this.model.selectedRole = node;
      this.model.roleRId = node.roleRId;
      this.model.name = node.name;
      this.model.definition = node.definition;
      this.model.allowedSiteSelectionNumber = node.allowedSiteSelectionNumber;
      this.model.parentRId = node.parentRId;
      if (!hasChild) {
        this.getActivitiesOfRole(node.roleRId);
        this.isDisableSeleted = false;
      } else {
        this.isDisableSeleted = true;
      }
    } else {
        this.model = {};
        this.currentSelectedNode = null;
        this.isDisabledEditBtn = true;
        this.isDisabledDeleteBtn = true;
        this.isDisabledAddBtn = false;
        this.selectedFeatures = '';
    }
    this.actionMode = ActionModeEnum.Viewing;
    this.setEnableForm();
    // if (!hasChild) {
    //   this.getActivitiesOfRole(node.roleRId);
    //   this.isDisableSeleted = false;
    // } else {
    //   this.isDisableSeleted = true;
    // }

  }
  private clearRoleModel = () => {
    this.model.roleRId = '';
    this.model.name = '';
    this.model.definition = '';
    this.model.allowedSiteSelectionNumber = '';
  }
  private getActivitiesOfRole = (roleRId: any) => {
    this.userManagementService.getActivitiesOfRole(roleRId).subscribe(data => {
      // Bind data
      if (data.data) {
        const activityRIds = data.data.map((x: any) => x.activityRId);
        this.bindRoleSelectedToFeature(activityRIds);
      }
    });
  }
  // End event On tree
  private setEnableForm = () => {
    const roleNameCtr = this.formData.get('roleNameCtr');
    const definitionCtr = this.formData.get('definitionCtr');
    const allowedSiteSelectionNumberCtr = this.formData.get('allowedSiteSelectionNumberCtr');
    switch (this.actionMode) {
      case ActionModeEnum.Creating:
      case ActionModeEnum.Editing:
        roleNameCtr.enable();
        definitionCtr.enable();
        allowedSiteSelectionNumberCtr.enable();
        this.isDisabledCancelBtn = false;
        break;
      case ActionModeEnum.Viewing:
      roleNameCtr.disable();
      definitionCtr.disable();
      allowedSiteSelectionNumberCtr.disable();
      this.isDisabledCancelBtn = true;
        break;
      default:
        break;
    }
    roleNameCtr.updateValueAndValidity();
    definitionCtr.updateValueAndValidity();
    allowedSiteSelectionNumberCtr.updateValueAndValidity();
  }
  private getFeatures = () => {
    this.userManagementService.getAllActivities().subscribe(data => {
      this.features = data.data as FeatureModel[];
    this.featuresDataSource = new MatTableDataSource<any>(this.features);
    this.featuresDataSource.filterPredicate = this.createFilter();
    this.featuresDataSource.paginator = this.paginator;
    });
  }
  // public onSelectedRoleChange = () => {
  //   this.clearSelectedFeatures();
  //   if (this.model.selectedRole) {
  //     this.isDisabledEditBtn = false;
  //     this.bindRoleSelectedToFeature();
  //   } else {
  //     this.isDisabledEditBtn = true;
  //   }
  //   this.actionMode = ActionModeEnum.Viewing;
  //   this.setEnableForm();
  // }
  private bindRoleSelectedToFeature = (activityRIds: any) => {
    if (activityRIds) {
      this.featuresDataSource.data.forEach(item => {
        if (activityRIds.filter((x: any) => x === item.activityRId).length === 1) {
          item.selected = true;
        }
      });
      this.onChangeFeature();
    } else {
      this.selectedFeatures = '';
    }
  }
  private clearSelectedFeatures = () => {
    this.featuresDataSource.data.forEach(item => {
        item.selected = false;
    });
    this.selectedFeatures = '';
  }
  private setDisabledAllowedSiteSelectionNumber = (isSelectedNode: boolean, node?: any) => {
    this.allowedSiteSelectionNumber.forEach(x => x.disabled = false);
    if (isSelectedNode && node !== null) {
      this.allowedSiteSelectionNumber.forEach(x => {
        if (x.value === node.allowedSiteSelectionNumber) {
          x.disabled = false;
        } else {
          x.disabled = true;
        }
      });
    }
  }
  public edit = (event: any) => {
    event.preventDefault();
    const hasChild = this.currentSelectedNode.childrentRole.length > 0;
    this.bindRoleModelBaseOnSelectedRole(this.currentSelectedNode, true, hasChild);
    this.actionMode = ActionModeEnum.Editing;
    this.setEnableForm();
  }
  public add = (event?: any) => {
    if (event) {
      event.preventDefault();
    }
    this.actionMode = ActionModeEnum.Creating;
    // this.formDirective.resetForm();
    // this.formData.reset();
    this.setEnableForm();
    this.clearRoleModel();
    this.clearSelectedFeatures();
  }
  public delete = (event: any) => {
    // this.actionMode = ActionModeEnum.Deleting;
    event.preventDefault();
    const dialogRef = this.dialog.open(ConfirmationDialog, {
      width: '50%'
    });
    dialogRef.componentInstance.confirmMessage = Constants.MESSAGE.Delete_Confirm;
    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.userManagementService.deleteRole(this.currentSelectedNode.roleRId).subscribe(data => {
          if (data.code === 200) {
            this.alertService.message = Constants.MESSAGE.Delete_success;
            this.alertService.showSuccess();
            this.actionMode = ActionModeEnum.Deleting;
            // Parent node and set selected
            const temp = this.getParentNode(this.currentSelectedNode);
            if (temp !== null) {
              this.currentSelectedNode = temp;
              this.clearSelectedFeatures();
              this.getActivitiesOfRole(this.currentSelectedNode.roleRId);
            } else {
              this.currentSelectedNode = null;
              this.formDirective.resetForm();
              this.formData.reset();
              this.setEnableForm();
              this.clearRoleModel();
              this.clearSelectedFeatures();
              this.isDisabledEditBtn = true;
              this.isDisabledDeleteBtn = true;
            }
            this.reset();
            this.getRoleTreeAndSetSelectedRole();
          } else {
            this.alertService.message = Constants.MESSAGE.Delete_failure;
            this.alertService.showError();
          }
        });
      }
    });
  }
  public reset = (event?: any) => {
    if (event) {
      event.preventDefault();
    }
    // this.model = new
    switch (this.actionMode) {
      case ActionModeEnum.Creating:
        this.add(event);
        break;
      case ActionModeEnum.Editing:
        this.edit(event);
        break;
        case ActionModeEnum.Deleting:
          this.actionMode = ActionModeEnum.Viewing;
          break;
      default:
        break;
    }
  }
  public submit = () => {
    const self = this;
    const newModel = cloneDeep(this.model);
    newModel.activities = [];
    const features = this.getFeaturesSelected();
    if (newModel.selectable && features.length === 0) {
          this.onOpenAlertBox('Please select at least one feature.');
          return;
    }
    newModel.activities = features;
    delete newModel.selectedRole;
    switch (this.actionMode) {
      case ActionModeEnum.Creating:
        newModel.parentRId = (this.currentSelectedNode !== undefined && this.currentSelectedNode !== null)
                            ? this.currentSelectedNode.roleRId : '';
        this.userManagementService.createNewRole(newModel).subscribe(data => {
            this.alertService.message = Constants.MESSAGE.AddSuccessMess;
            this.alertService.showSuccess();
            if (this.currentSelectedNode) {
              this.currentSelectedNode.childrentRole.push(data.data);
            }
            this.getRoleTreeAndSetSelectedRole();
            this.reset();
        });
        break;
      case ActionModeEnum.Editing:
        this.userManagementService.updateRole(newModel).subscribe(data => {
          this.alertService.message = Constants.MESSAGE.EditSuccessMess;
          this.alertService.showSuccess();
          this.currentSelectedNode = data.data;
          this.getRoleTreeAndSetSelectedRole();
          // this.reset();
        });
        break;
      default:
        break;
    }
  }
  private getParentNode = (node: any) => {
    const currentLevel = this.treeControl.getLevel(node);
    if (currentLevel < 1) {
      return null;
    }
    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;
    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];

      if (this.treeControl.getLevel(currentNode) < currentLevel) {
        return currentNode;
      }
    }
  }
  private getFeaturesSelected = () => {
    const result = [];
    for (let i = 0; i < this.featuresDataSource.data.length; i++) {
      const feature = this.featuresDataSource.data[i];
      if (feature.selected) {
        delete feature.selected;
        result.push(feature);
      }
    }
    return result;
  }
  private onOpenAlertBox = (description: string) => {
    const dialogRef = this.dialog.open(WarningDialog, { width: '50%'});
    dialogRef.componentInstance.confirmMessage = description;
  }
  public search = (term: string) => {
    let temp = '';
    if (term.length > 0) {
      temp = term.trim().toLowerCase();
    }
    this.featureNameSearch = temp;
    this.filterValues.name = temp;
    this.featuresDataSource.filter = JSON.stringify(this.filterValues);
  }
  public onModificationTypeChange = () => {
    this.filterValues.name = this.featureNameSearch;
    if (this.selectedModificationType === 1) {
      this.filterValues.modificationTypeString = '';
    } else {
      // tslint:disable-next-line:max-line-length
      this.filterValues.modificationTypeString = this.modificationType.filter(x => x.value === this.selectedModificationType).map(y => y.name)[0];
      this.filterValues.modificationTypeString = this.filterValues.modificationTypeString.toLowerCase();
    }
    this.featuresDataSource.filter = JSON.stringify(this.filterValues);
}
createFilter(): (data: any, filter: string) => boolean {
  const filterFunction = (data: any, filter: any): boolean => {
    const searchTerms = JSON.parse(filter);
    // return data.modificationType.toLowerCase().indexOf(searchTerms.modificationType) !== -1
    //   && data.featureName.toString().toLowerCase().indexOf(searchTerms.featureName) !== -1;
    return data.modificationTypeString.toLowerCase().includes(searchTerms.modificationTypeString)
    && data.name.toString().toLowerCase().includes(searchTerms.name);
  };
  return filterFunction;
}
  public onChangeFeature = () => {
    this.selectedFeatures = this.featuresDataSource.data.filter(x => x.selected === true).length.toString();
  }
  public isFieldHasError = (fieldName: string, errorCode: string): boolean => {
    return this.formData.get(fieldName).hasError(errorCode);
  }
}
